import React, { CSSProperties, FunctionComponent } from 'react';
import { Responsive } from 'rs-emd-ui-atoms';
import { IImageDataWidget } from '../../../../models/campaign-pages/widgets/image/image-data.model';
import styles from './image-widget-component.module.scss';

export type ImageProps = {
  image: IImageDataWidget;
  imageContainerClassName?: string;
  imageWrapperClassName?: string;
  isContainerFullHeight?: boolean;
  maxImgHeight?: number;
};

export const ImageWidget: FunctionComponent<ImageProps> = (props: ImageProps) => {
  let ContainerTag = (props.image.link?.URL ? 'a' : 'div') as keyof JSX.IntrinsicElements;
  let linkAttributes =
    ContainerTag === 'a' ? { href: props.image.link?.URL ?? undefined, target: props.image.link?.target ?? undefined } : {};

  const imgInlineStyle = (props.maxImgHeight
    ? {
        height: `${props.maxImgHeight}px`,
        objectFit: 'contain', //to maintain img ratio
      }
    : {}) as CSSProperties;

  return (
    <div
      className={`${styles['image-container']} ${styles['desktop-horiz-alignment-' + props.image.imageHorizontalAlignment?.desktop]} ${
        styles['mobile-horiz-alignment-' + props.image.imageHorizontalAlignment?.mobile]
      } ${props.imageContainerClassName}`}
      style={{ '--container-height': props.isContainerFullHeight ? '100%' : 'auto' } as CSSProperties}>
      <ContainerTag
        {...linkAttributes}
        className={`${styles['image-wrapper']} ${styles['desktop-vert-alignment-' + props.image.imageVerticalAlignment?.desktop]} ${
          styles['mobile-vert-alignment-' + props.image.imageVerticalAlignment?.mobile]
        } ${props.imageWrapperClassName}`}
        style={
          {
            '--desktop-image-width-percentage': props.image.image?.desktop?.width ?? 'auto',
            '--tablet-image-width-percentage': props.image.image?.tablet?.width ?? 'auto',
            '--mobile-image-width-percentage': props.image.image?.mobile?.width ?? 'auto',
          } as CSSProperties
        }>
        <Responsive breakpoints={['desktop', 'lg-desktop', 'xl-desktop']}>
          {props.image.image?.desktop?.url && (
            <img
              className={`${styles.image} `}
              src={props.image.image?.desktop?.url}
              alt={props.image.image?.alt}
              title={props.image.image?.description}
              style={imgInlineStyle}
            />
          )}
        </Responsive>
        <Responsive breakpoints={['tablet']}>
          {props.image.image?.tablet?.url && (
            <img
              className={styles.image}
              src={props.image.image?.tablet?.url}
              alt={props.image.image?.alt}
              title={props.image.image?.description}
              style={imgInlineStyle}
            />
          )}
        </Responsive>
        <Responsive breakpoints={['mobile']}>
          {props.image.image?.mobile?.url && (
            <img
              className={styles.image}
              src={props.image.image?.mobile?.url}
              alt={props.image.image?.alt}
              title={props.image.image?.description}
              style={imgInlineStyle}
            />
          )}
        </Responsive>
      </ContainerTag>
    </div>
  );
};

ImageWidget.defaultProps = {
  isContainerFullHeight: true,
};

export default ImageWidget;
